import React from "react";
import { OperationsDashboard } from "../components/OperationsDashboard";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Sales pipeline health & movement",
  charts: [],
  filters: [],
  Component: () =>
    React.createElement(OperationsDashboard, {
      variant: "sales_pipeline_health",
    }),
};
